var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"verticals"},_vm._l((['中央空调', '夹层', '水泵']),function(item,index){return _c('div',{key:index,staticClass:"verticals__item"},[_c('div',{staticClass:"verticals__item-title"},[_vm._v(_vm._s(item))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }